// Mapping canonique des routes FR <-> EN.
// Les chemins FR sont la référence canonique : les composants écrivent toujours
// des liens avec le chemin FR, et l() les localise selon la langue courante.

export const STATIC_PATHS = [
  { key: "home", fr: "/", en: "/en" },
  { key: "about", fr: "/qui-suis-je", en: "/en/about" },
  { key: "services", fr: "/services", en: "/en/services" },
  { key: "blog", fr: "/blog", en: "/en/blog" },
  { key: "contact", fr: "/contact", en: "/en/contact" },
  { key: "faq", fr: "/faq", en: "/en/faq" },
  { key: "legal", fr: "/mentions-legales", en: "/en/legal-notice" },
  { key: "privacy", fr: "/politique-de-confidentialite", en: "/en/privacy-policy" },
];

export const OFFER_SLUGS = [
  { fr: "diagnostic-marketing-strategique", en: "marketing-strategy-diagnostic" },
  { fr: "plan-de-lancement-go-to-market", en: "go-to-market-launch-plan" },
  { fr: "direction-marketing-externalisee", en: "fractional-cmo-outsourced-marketing" },
];

export const ARTICLE_SLUGS = [
  { fr: "marketing-b2b-cote-d-azur-decideurs-locaux", en: "b2b-marketing-french-riviera-local-decision-makers" },
  { fr: "accompagnement-marketing-dirigeant-pme", en: "marketing-support-for-sme-owners" },
  { fr: "diagnostic-marketing-5-etapes", en: "marketing-audit-5-steps" },
  { fr: "go-to-market-lancement-produit-startup", en: "go-to-market-product-launch-startup" },
  { fr: "fractional-cmo-direction-marketing-externalisee", en: "fractional-cmo-practical-guide" },
  { fr: "strategie-de-marque-positionnement", en: "brand-strategy-positioning" },
  { fr: "ia-marketing-cas-usage-pme", en: "ai-marketing-use-cases-smes" },
];

const frToEn = new Map();
const enToFr = new Map();

STATIC_PATHS.forEach(({ fr, en }) => {
  frToEn.set(fr, en);
  enToFr.set(en, fr);
});
OFFER_SLUGS.forEach(({ fr, en }) => {
  frToEn.set(`/services/${fr}`, `/en/services/${en}`);
  enToFr.set(`/en/services/${en}`, `/services/${fr}`);
});
ARTICLE_SLUGS.forEach(({ fr, en }) => {
  frToEn.set(`/blog/${fr}`, `/en/blog/${en}`);
  enToFr.set(`/en/blog/${en}`, `/blog/${fr}`);
});

const normalize = (p) => (p.length > 1 && p.endsWith("/") ? p.slice(0, -1) : p);

export const langFromPath = (pathname) =>
  pathname === "/en" || pathname.startsWith("/en/") ? "en" : "fr";

export const toEnglishPath = (frPath) => {
  const p = normalize(frPath);
  return frToEn.get(p) || `/en${p === "/" ? "" : p}`;
};

export const toFrenchPath = (enPath) => {
  const p = normalize(enPath);
  return enToFr.get(p) || "/";
};

// Localise un chemin FR canonique vers la langue demandée.
export const localizePath = (frPath, lang) => (lang === "en" ? toEnglishPath(frPath) : normalize(frPath));

// Toutes les routes pré-rendues (FR + EN) — utilisé par sitemap et prerender.
export const ALL_FR_PATHS = [...frToEn.keys()];
export const ALL_EN_PATHS = [...frToEn.values()];
